/**
 * VuePrint v1.6.3
 * Copyright (c) 2024 Jak Guru LLC
 * Vueprint a commerical work product released under the MIT License
 * and is provided as-is with no warranty or guarantee of support.
 * Documentation: https://jakguru.github.io/vueprint/
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import Bowser from 'bowser';

const getBrowserInfo = () => {
  if ("undefined" === typeof window || "undefined" === typeof window.navigator || "undefined" === typeof window.navigator.userAgent) {
    if ("undefined" !== typeof ServiceWorkerGlobalScope && self instanceof ServiceWorkerGlobalScope) {
      return {
        browserName: "Service Worker",
        browserVersion: "0.0.0",
        osName: "Unknown",
        osVersion: "0.0.0",
        platformType: "Service Worker",
        engineName: "Service Worker",
        engineVersion: "0.0.0"
      };
    }
    return {
      browserName: "SSR",
      browserVersion: "0.0.0",
      osName: "Unknown",
      osVersion: "0.0.0",
      platformType: "SSR",
      engineName: "SSR",
      engineVersion: "0.0.0"
    };
  }
  const parsed = Bowser.parse(window.navigator.userAgent);
  return {
    browserName: parsed.browser.name || "Unknown",
    browserVersion: parsed.browser.version || "0.0.0",
    osName: parsed.os.name || "Unknown",
    osVersion: parsed.os.version || "0.0.0",
    platformType: parsed.platform.type || "Unknown",
    engineName: parsed.engine.name || "Unknown",
    engineVersion: parsed.engine.version || "0.0.0"
  };
};

const browser = {
  __proto__: null,
  getBrowserInfo: getBrowserInfo
};

export { browser as b, getBrowserInfo as g };
//# sourceMappingURL=vueprint.73231624.mjs.map
